import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setUserManagementPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useUserManagementSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getUserManagementSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.user_management_page?.user_management_section}`);
      console.log("🚀 ~ getUserManagementSectionJson ~ data:", response);
      console.log("🚀 ~ getUserManagementSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setUserManagementPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching User Management section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getUserManagementSectionJson();
  }, [getUserManagementSectionJson]);

  return {
    data,
    loading,
    error,
    getUserManagementSectionJson,
    fetchOnMount,
    refetch: getUserManagementSectionJson
  };
};

export default useUserManagementSection;
